import { useMemo } from "react";
import { Box, Button } from "@mui/material";
import styles from './styles.module.scss';
import clsx from 'clsx';

const TraceFile = (props) => {
    const { traceRuns, compact = false } = props;

    const findNewestRun = useMemo(() => traceRuns.reduce((latest, current) => {
        if (!latest) return current;
        return new Date(current.updated_at) > new Date(latest.updated_at) ? current : latest;
    }, null), [traceRuns]);

    const handleInspectClick = () => {
        const viewerUrl = `https://trace.playwright.dev/?trace=${encodeURIComponent(findNewestRun.aws_tracing_url)}`;
        window.open(viewerUrl, '_blank');
    };

    if (!traceRuns || !findNewestRun || !findNewestRun.aws_tracing_url) return null;

    return (
        <Box className={clsx(styles.traceContainer, compact ? styles.compact : '')}>
            {!compact && (
                <Box className={styles.traceButtonContainer}>
                    <Button
                        variant="contained"
                        color="secondary"
                        className={styles.traceButton}
                        href={findNewestRun.aws_tracing_url}
                    >
                        Download latest trace file
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        className={clsx(styles.traceButton, styles.inspectTraceButton)}
                        onClick={handleInspectClick}
                    >
                        Inspect latest trace file
                    </Button>
                </Box>
            )}
        </Box>
    );
}

export default TraceFile;
